/**
 * BrandsLogos.tsx — Gold Garage Door / Brands · Section 2/8
 * Cream · full 12-brand logo grid · each card = brand name + "repairs & installs" tag.
 * MOBILE: auto-fit grid (already responsive) + real <style> for tightening.
 * 10WEB AI: keep <img> + <style>. Wave dividers intentional — do NOT strip.
 */

const NAVY = "#081438";
const GOLD = "#F5A623";
const GOLD_DARK = "#9A6400";
const INK = "#1A1F2E";
const CREAM = "#FAF7F1";
const BRANDS = [{
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/b5706f1be_58dae4e4d_BD_Australia_Logo.webp",
  alt: "B&D",
  note: "Australia's most common residential brand"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/24bd15fa9_a095621ff_Merlin-Logo-Positive.webp",
  alt: "Merlin",
  note: "Openers, motors & remotes"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/ata-logo-min-300x226.png.webp",
  alt: "ATA",
  note: "Automation & control systems"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/centurion-garage-doors.webp",
  alt: "Centurion",
  note: "Sectional & panel doors"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/steel-line-garage-doors.webp",
  alt: "Steel-Line",
  note: "Steel sectional & roller doors"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/7656bc9c2_c348bc03e_gliderol-logo.webp",
  alt: "Gliderol",
  note: "Roller & sectional specialists"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/liftmaster.webp",
  alt: "LiftMaster",
  note: "Premium openers & motors"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/marantec.webp",
  alt: "Marantec",
  note: "German-engineered drives"
}, {
  src: "https://goldgaragedoor.com.au/wp-content/uploads/2026/05/grifco.webp?v=lme0iqfufzf",
  alt: "Grifco",
  note: "Commercial roller-door motors"
}, {
  src: "https://goldgaragedoor.com.au/wp-content/uploads/2026/05/5e385702d_6c94e3d82_superliftlogo-1.webp?v=woq6cve8yh",
  alt: "Superlift",
  note: "Industrial door operators"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/hormann.webp",
  alt: "Hörmann",
  note: "European sectional doors"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/doors-industrial.webp",
  alt: "4D Industrial",
  note: "Heavy-duty industrial doors"
}];
export default function BrandsLogos() {
  return <section id="brands-logos" style={{
    background: CREAM,
    position: "relative",
    overflow: "hidden",
    paddingTop: "5.5rem",
    paddingBottom: "5.5rem"
  }}>
      <style>{`
        .bl-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 1rem; }
        @media (max-width: 880px) { .bl-grid { grid-template-columns: repeat(3, 1fr); } }
        @media (max-width: 600px) {
          .bl-grid { grid-template-columns: repeat(2, 1fr); gap: 0.75rem; }
          #brands-logos { padding-top: 3.5rem; padding-bottom: 3.5rem; }
        }
      `}</style>

      <div aria-hidden style={{
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      lineHeight: 0,
      transform: "rotate(180deg)"
    }}>
        <svg viewBox="0 0 1440 48" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style={{
        display: "block",
        width: "100%",
        height: "48px"
      }}><path d="M0,48 C360,0 1080,0 1440,48 L1440,48 L0,48 Z" fill={NAVY} /></svg>
      </div>

      <svg aria-hidden style={{
      position: "absolute",
      inset: 0,
      width: "100%",
      height: "100%",
      opacity: 0.4,
      pointerEvents: "none",
      mixBlendMode: "multiply"
    }}><filter id="paper-bl"><feTurbulence type="fractalNoise" baseFrequency="0.04" numOctaves="5" stitchTiles="stitch" /><feColorMatrix type="matrix" values="0 0 0 0 0.85, 0 0 0 0 0.82, 0 0 0 0 0.74, 0 0 0 0.08 0" /></filter><rect width="100%" height="100%" filter="url(#paper-bl)" /></svg>

      <div aria-hidden style={{
      position: "absolute",
      top: "5rem",
      left: "2rem",
      width: "60px",
      height: "60px",
      borderTop: `2px solid ${GOLD}55`,
      borderLeft: `2px solid ${GOLD}55`,
      pointerEvents: "none",
      zIndex: 1
    }} />

      <div style={{
      maxWidth: "1150px",
      margin: "0 auto",
      padding: "0 1.5rem",
      position: "relative",
      zIndex: 1
    }}>
        <div style={{
        textAlign: "center",
        maxWidth: "620px",
        margin: "0 auto 3rem"
      }}>
          <span style={{
          fontFamily: "'Manrope', sans-serif",
          fontSize: "0.72rem",
          fontWeight: 700,
          letterSpacing: "0.16em",
          color: GOLD_DARK,
          textTransform: "uppercase"
        }}>The Full List</span>
          <h2 style={{
          fontFamily: "'Plus Jakarta Sans', sans-serif",
          fontWeight: 800,
          fontSize: "clamp(1.65rem, 6vw, 2.6rem)",
          color: NAVY,
          lineHeight: 1.15,
          margin: "0.75rem 0 0.75rem"
        }}>Brands we repair & install</h2>
          <p style={{
          fontFamily: "'Manrope', sans-serif",
          fontSize: "1.02rem",
          color: INK,
          lineHeight: 1.7
        }}>From the biggest names in Australian garage doors to specialist commercial operators — we know them all.</p>
        </div>

        <div className="bl-grid">
          {BRANDS.map((b, i) => <div key={i} style={{
          background: "#fff",
          border: `1px solid ${GOLD}22`,
          borderRadius: "14px",
          padding: "1.5rem 1.25rem",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          gap: "0.85rem",
          boxShadow: "0 6px 22px rgba(8,20,56,0.05)"
        }}>
              <div style={{
            height: "48px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%"
          }}>
                <img src={b.src} alt={`${b.alt} garage doors serviced by Gold Garage Door`} width={120} height={40} loading="lazy" decoding="async" style={{
              maxHeight: "40px",
              maxWidth: "100%",
              width: "auto",
              objectFit: "contain"
            }} />
              </div>
              <div style={{
            width: "28px",
            height: "2px",
            background: `${GOLD}66`
          }} />
              <div>
                <div style={{
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              fontWeight: 800,
              fontSize: "0.95rem",
              color: NAVY
            }}>{b.alt}</div>
                <div style={{
              fontFamily: "'Manrope', sans-serif",
              fontSize: "0.78rem",
              color: INK,
              lineHeight: 1.4,
              marginTop: "0.25rem"
            }}>{b.note}</div>
              </div>
            </div>)}
        </div>

        <p style={{
        textAlign: "center",
        fontFamily: "'Manrope', sans-serif",
        fontSize: "0.9rem",
        color: GOLD_DARK,
        marginTop: "2.5rem",
        fontWeight: 600
      }}>
          Don't see your brand? Call <a href="tel:0485000933" style={{
          color: NAVY,
          fontWeight: 800,
          textDecoration: "none",
          borderBottom: `2px solid ${GOLD}`
        }}>0485 000 933</a> — if it's a garage door, we fix it.
        </p>
      </div>

      <div aria-hidden style={{
      position: "absolute",
      bottom: 0,
      left: 0,
      right: 0,
      lineHeight: 0
    }}>
        <svg viewBox="0 0 1440 48" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style={{
        display: "block",
        width: "100%",
        height: "48px"
      }}><path d="M0,48 C360,0 1080,0 1440,48 L1440,48 L0,48 Z" fill={NAVY} /></svg>
      </div>
    </section>;
}